<template>
    <Navigation />
    <Slips />
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import Slips from '../components/Slips.vue';


export default {
  name: 'Home',
  components: {
    Navigation,
    Slips
}
}
</script>